import React from 'react';

import { IonContent, IonPopover } from '@ionic/react';

import { useCurrencyFormat, useNumberFormat, usePercentFormat } from 'intl';

const dimensionMetricType = null;

export const DimensionColumn = ({ cellData }: { cellData: { value: any } }) => {
  const triggerId = `click-trigger-${cellData.value.replaceAll(' ', '-')}`;
  return (
    <>
      <span id={triggerId}>{cellData.value}</span>
      <IonPopover
        trigger={triggerId}
        triggerAction={'click'}
        side={'right'}
        alignment={'center'}
      >
        <IonContent class={'ion-padding'}>{cellData.value}</IonContent>
      </IonPopover>
    </>
  );
};
export const NumberColumn = ({ cellData }: { cellData: { value: any } }) => {
  const numberFormat = useNumberFormat();
  return <span>{numberFormat(cellData.value)}</span>;
};

export const PercentColumn = ({ cellData }: { cellData: { value: any } }) => {
  const percentFormat = usePercentFormat();
  return <span>{percentFormat(cellData.value)}</span>;
};

export const CurrencyColumn = ({ cellData }: { cellData: { value: any } }) => {
  const currencyFormat = useCurrencyFormat();
  return <span>{currencyFormat(cellData.value)}</span>;
};

const Cells = ({ cellData, metricType }: any) => {
  if (!cellData || cellData.value === null || cellData.value === undefined) {
    return '';
  }

  switch (metricType) {
    case dimensionMetricType:
      return <DimensionColumn cellData={cellData} />;
    case 'number':
      return <NumberColumn cellData={cellData} />;
    case 'percent':
      return <PercentColumn cellData={cellData} />;
    case 'currency':
      return <CurrencyColumn cellData={cellData} />;
  }
  return cellData.value;
};
export default Cells;
